module.exports = __webpack_public_path__ + "static/img/01.64f7eea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour1/01.jpg
// module id = hRCT
// module chunks = 0